import React from "react";
import CardSlide from "./card_slide";

const NewPd = ({SlideData}) => {
     return <div className="py-14">
     {/* <h1 className="text-center">New Product</h1> */}
          <div className="">
               <CardSlide SlideData={SlideData} title={"New Product"} />
       </div>
  </div>;
};

export default NewPd;
